import React from "react";
import { Assets } from "utils/imports.utils";
import { STRINGS } from "constants/strings.constant";
import { ModalCloseButtonProps } from "interfaces/payment_modal.interface";
import "./modal_close_button.component.scss";

// The X in a modal's top-right corner. The modal around it must be position: relative.
const ModalCloseButton = (props: ModalCloseButtonProps): React.ReactElement => {
    // The modal renders in a portal, but React still bubbles the click up the component tree to whatever opened it.
    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        props.onClose();
    };

    return (
        <button type="button" className="modal_close_button" onClick={handleClick}>
            <img src={Assets.close_black} alt={STRINGS.modal.closeAlt} />
        </button>
    );
};

export default ModalCloseButton;
